/**
 * @fileoverview gRPC-Web generated client stub for verily.sdp.studysite.v1alpha1
 * @enhanceable
 * @public
 */

// Code generated by protoc-gen-grpc-web. DO NOT EDIT.
// versions:
// 	protoc-gen-grpc-web v1.4.2
// 	protoc              v3.20.3
// source: studysite/studysite.proto


/* eslint-disable */
// @ts-nocheck



const grpc = {};
grpc.web = require('grpc-web');


var google_api_annotations_pb = require('../google/api/annotations_pb.js')

var google_api_client_pb = require('../google/api/client_pb.js')

var google_api_field_behavior_pb = require('../google/api/field_behavior_pb.js')

var google_api_resource_pb = require('../google/api/resource_pb.js')

var google_protobuf_empty_pb = require('google-protobuf/google/protobuf/empty_pb.js')

var google_type_date_pb = require('../google/type/date_pb.js')

var common_historyinformation_pb = require('../common/historyinformation_pb.js')

var common_fieldchangelog_pb = require('../common/fieldchangelog_pb.js')
const proto = {};
proto.verily = {};
proto.verily.sdp = {};
proto.verily.sdp.studysite = {};
proto.verily.sdp.studysite.v1alpha1 = require('./studysite_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.verily.sdp.studysite.v1alpha1.StudySiteServiceClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'binary';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.verily.sdp.studysite.v1alpha1.StudySiteServicePromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'binary';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.verily.sdp.studysite.v1alpha1.CreateStudySiteRequest,
 *   !proto.verily.sdp.studysite.v1alpha1.StudySite>}
 */
const methodDescriptor_StudySiteService_CreateStudySite = new grpc.web.MethodDescriptor(
  '/verily.sdp.studysite.v1alpha1.StudySiteService/CreateStudySite',
  grpc.web.MethodType.UNARY,
  proto.verily.sdp.studysite.v1alpha1.CreateStudySiteRequest,
  proto.verily.sdp.studysite.v1alpha1.StudySite,
  /**
   * @param {!proto.verily.sdp.studysite.v1alpha1.CreateStudySiteRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.verily.sdp.studysite.v1alpha1.StudySite.deserializeBinary
);


/**
 * @param {!proto.verily.sdp.studysite.v1alpha1.CreateStudySiteRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.verily.sdp.studysite.v1alpha1.StudySite)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.verily.sdp.studysite.v1alpha1.StudySite>|undefined}
 *     The XHR Node Readable Stream
 */
proto.verily.sdp.studysite.v1alpha1.StudySiteServiceClient.prototype.createStudySite =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/verily.sdp.studysite.v1alpha1.StudySiteService/CreateStudySite',
      request,
      metadata || {},
      methodDescriptor_StudySiteService_CreateStudySite,
      callback);
};


/**
 * @param {!proto.verily.sdp.studysite.v1alpha1.CreateStudySiteRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.verily.sdp.studysite.v1alpha1.StudySite>}
 *     Promise that resolves to the response
 */
proto.verily.sdp.studysite.v1alpha1.StudySiteServicePromiseClient.prototype.createStudySite =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/verily.sdp.studysite.v1alpha1.StudySiteService/CreateStudySite',
      request,
      metadata || {},
      methodDescriptor_StudySiteService_CreateStudySite);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.verily.sdp.studysite.v1alpha1.UpdateStudySiteRequest,
 *   !proto.verily.sdp.studysite.v1alpha1.StudySite>}
 */
const methodDescriptor_StudySiteService_UpdateStudySite = new grpc.web.MethodDescriptor(
  '/verily.sdp.studysite.v1alpha1.StudySiteService/UpdateStudySite',
  grpc.web.MethodType.UNARY,
  proto.verily.sdp.studysite.v1alpha1.UpdateStudySiteRequest,
  proto.verily.sdp.studysite.v1alpha1.StudySite,
  /**
   * @param {!proto.verily.sdp.studysite.v1alpha1.UpdateStudySiteRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.verily.sdp.studysite.v1alpha1.StudySite.deserializeBinary
);


/**
 * @param {!proto.verily.sdp.studysite.v1alpha1.UpdateStudySiteRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.verily.sdp.studysite.v1alpha1.StudySite)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.verily.sdp.studysite.v1alpha1.StudySite>|undefined}
 *     The XHR Node Readable Stream
 */
proto.verily.sdp.studysite.v1alpha1.StudySiteServiceClient.prototype.updateStudySite =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/verily.sdp.studysite.v1alpha1.StudySiteService/UpdateStudySite',
      request,
      metadata || {},
      methodDescriptor_StudySiteService_UpdateStudySite,
      callback);
};


/**
 * @param {!proto.verily.sdp.studysite.v1alpha1.UpdateStudySiteRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.verily.sdp.studysite.v1alpha1.StudySite>}
 *     Promise that resolves to the response
 */
proto.verily.sdp.studysite.v1alpha1.StudySiteServicePromiseClient.prototype.updateStudySite =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/verily.sdp.studysite.v1alpha1.StudySiteService/UpdateStudySite',
      request,
      metadata || {},
      methodDescriptor_StudySiteService_UpdateStudySite);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.verily.sdp.studysite.v1alpha1.DeleteStudySiteRequest,
 *   !proto.google.protobuf.Empty>}
 */
const methodDescriptor_StudySiteService_DeleteStudySite = new grpc.web.MethodDescriptor(
  '/verily.sdp.studysite.v1alpha1.StudySiteService/DeleteStudySite',
  grpc.web.MethodType.UNARY,
  proto.verily.sdp.studysite.v1alpha1.DeleteStudySiteRequest,
  google_protobuf_empty_pb.Empty,
  /**
   * @param {!proto.verily.sdp.studysite.v1alpha1.DeleteStudySiteRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  google_protobuf_empty_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.verily.sdp.studysite.v1alpha1.DeleteStudySiteRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.google.protobuf.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.google.protobuf.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.verily.sdp.studysite.v1alpha1.StudySiteServiceClient.prototype.deleteStudySite =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/verily.sdp.studysite.v1alpha1.StudySiteService/DeleteStudySite',
      request,
      metadata || {},
      methodDescriptor_StudySiteService_DeleteStudySite,
      callback);
};


/**
 * @param {!proto.verily.sdp.studysite.v1alpha1.DeleteStudySiteRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.google.protobuf.Empty>}
 *     Promise that resolves to the response
 */
proto.verily.sdp.studysite.v1alpha1.StudySiteServicePromiseClient.prototype.deleteStudySite =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/verily.sdp.studysite.v1alpha1.StudySiteService/DeleteStudySite',
      request,
      metadata || {},
      methodDescriptor_StudySiteService_DeleteStudySite);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.verily.sdp.studysite.v1alpha1.GetStudySiteRequest,
 *   !proto.verily.sdp.studysite.v1alpha1.StudySite>}
 */
const methodDescriptor_StudySiteService_GetStudySite = new grpc.web.MethodDescriptor(
  '/verily.sdp.studysite.v1alpha1.StudySiteService/GetStudySite',
  grpc.web.MethodType.UNARY,
  proto.verily.sdp.studysite.v1alpha1.GetStudySiteRequest,
  proto.verily.sdp.studysite.v1alpha1.StudySite,
  /**
   * @param {!proto.verily.sdp.studysite.v1alpha1.GetStudySiteRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.verily.sdp.studysite.v1alpha1.StudySite.deserializeBinary
);


/**
 * @param {!proto.verily.sdp.studysite.v1alpha1.GetStudySiteRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.verily.sdp.studysite.v1alpha1.StudySite)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.verily.sdp.studysite.v1alpha1.StudySite>|undefined}
 *     The XHR Node Readable Stream
 */
proto.verily.sdp.studysite.v1alpha1.StudySiteServiceClient.prototype.getStudySite =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/verily.sdp.studysite.v1alpha1.StudySiteService/GetStudySite',
      request,
      metadata || {},
      methodDescriptor_StudySiteService_GetStudySite,
      callback);
};


/**
 * @param {!proto.verily.sdp.studysite.v1alpha1.GetStudySiteRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.verily.sdp.studysite.v1alpha1.StudySite>}
 *     Promise that resolves to the response
 */
proto.verily.sdp.studysite.v1alpha1.StudySiteServicePromiseClient.prototype.getStudySite =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/verily.sdp.studysite.v1alpha1.StudySiteService/GetStudySite',
      request,
      metadata || {},
      methodDescriptor_StudySiteService_GetStudySite);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.verily.sdp.studysite.v1alpha1.ListStudySitesRequest,
 *   !proto.verily.sdp.studysite.v1alpha1.ListStudySitesResponse>}
 */
const methodDescriptor_StudySiteService_ListStudySites = new grpc.web.MethodDescriptor(
  '/verily.sdp.studysite.v1alpha1.StudySiteService/ListStudySites',
  grpc.web.MethodType.UNARY,
  proto.verily.sdp.studysite.v1alpha1.ListStudySitesRequest,
  proto.verily.sdp.studysite.v1alpha1.ListStudySitesResponse,
  /**
   * @param {!proto.verily.sdp.studysite.v1alpha1.ListStudySitesRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.verily.sdp.studysite.v1alpha1.ListStudySitesResponse.deserializeBinary
);


/**
 * @param {!proto.verily.sdp.studysite.v1alpha1.ListStudySitesRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.verily.sdp.studysite.v1alpha1.ListStudySitesResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.verily.sdp.studysite.v1alpha1.ListStudySitesResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.verily.sdp.studysite.v1alpha1.StudySiteServiceClient.prototype.listStudySites =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/verily.sdp.studysite.v1alpha1.StudySiteService/ListStudySites',
      request,
      metadata || {},
      methodDescriptor_StudySiteService_ListStudySites,
      callback);
};


/**
 * @param {!proto.verily.sdp.studysite.v1alpha1.ListStudySitesRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.verily.sdp.studysite.v1alpha1.ListStudySitesResponse>}
 *     Promise that resolves to the response
 */
proto.verily.sdp.studysite.v1alpha1.StudySiteServicePromiseClient.prototype.listStudySites =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/verily.sdp.studysite.v1alpha1.StudySiteService/ListStudySites',
      request,
      metadata || {},
      methodDescriptor_StudySiteService_ListStudySites);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.verily.sdp.studysite.v1alpha1.ListNonEmptyStudySitesRequest,
 *   !proto.verily.sdp.studysite.v1alpha1.ListNonEmptyStudySitesResponse>}
 */
const methodDescriptor_StudySiteService_ListNonEmptyStudySites = new grpc.web.MethodDescriptor(
  '/verily.sdp.studysite.v1alpha1.StudySiteService/ListNonEmptyStudySites',
  grpc.web.MethodType.UNARY,
  proto.verily.sdp.studysite.v1alpha1.ListNonEmptyStudySitesRequest,
  proto.verily.sdp.studysite.v1alpha1.ListNonEmptyStudySitesResponse,
  /**
   * @param {!proto.verily.sdp.studysite.v1alpha1.ListNonEmptyStudySitesRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.verily.sdp.studysite.v1alpha1.ListNonEmptyStudySitesResponse.deserializeBinary
);


/**
 * @param {!proto.verily.sdp.studysite.v1alpha1.ListNonEmptyStudySitesRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.verily.sdp.studysite.v1alpha1.ListNonEmptyStudySitesResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.verily.sdp.studysite.v1alpha1.ListNonEmptyStudySitesResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.verily.sdp.studysite.v1alpha1.StudySiteServiceClient.prototype.listNonEmptyStudySites =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/verily.sdp.studysite.v1alpha1.StudySiteService/ListNonEmptyStudySites',
      request,
      metadata || {},
      methodDescriptor_StudySiteService_ListNonEmptyStudySites,
      callback);
};


/**
 * @param {!proto.verily.sdp.studysite.v1alpha1.ListNonEmptyStudySitesRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.verily.sdp.studysite.v1alpha1.ListNonEmptyStudySitesResponse>}
 *     Promise that resolves to the response
 */
proto.verily.sdp.studysite.v1alpha1.StudySiteServicePromiseClient.prototype.listNonEmptyStudySites =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/verily.sdp.studysite.v1alpha1.StudySiteService/ListNonEmptyStudySites',
      request,
      metadata || {},
      methodDescriptor_StudySiteService_ListNonEmptyStudySites);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.verily.sdp.studysite.v1alpha1.ListStudySitesChangeLogsRequest,
 *   !proto.verily.sdp.studysite.v1alpha1.ListStudySitesChangeLogsResponse>}
 */
const methodDescriptor_StudySiteService_ListStudySitesChangeLogs = new grpc.web.MethodDescriptor(
  '/verily.sdp.studysite.v1alpha1.StudySiteService/ListStudySitesChangeLogs',
  grpc.web.MethodType.UNARY,
  proto.verily.sdp.studysite.v1alpha1.ListStudySitesChangeLogsRequest,
  proto.verily.sdp.studysite.v1alpha1.ListStudySitesChangeLogsResponse,
  /**
   * @param {!proto.verily.sdp.studysite.v1alpha1.ListStudySitesChangeLogsRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.verily.sdp.studysite.v1alpha1.ListStudySitesChangeLogsResponse.deserializeBinary
);


/**
 * @param {!proto.verily.sdp.studysite.v1alpha1.ListStudySitesChangeLogsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.verily.sdp.studysite.v1alpha1.ListStudySitesChangeLogsResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.verily.sdp.studysite.v1alpha1.ListStudySitesChangeLogsResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.verily.sdp.studysite.v1alpha1.StudySiteServiceClient.prototype.listStudySitesChangeLogs =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/verily.sdp.studysite.v1alpha1.StudySiteService/ListStudySitesChangeLogs',
      request,
      metadata || {},
      methodDescriptor_StudySiteService_ListStudySitesChangeLogs,
      callback);
};


/**
 * @param {!proto.verily.sdp.studysite.v1alpha1.ListStudySitesChangeLogsRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.verily.sdp.studysite.v1alpha1.ListStudySitesChangeLogsResponse>}
 *     Promise that resolves to the response
 */
proto.verily.sdp.studysite.v1alpha1.StudySiteServicePromiseClient.prototype.listStudySitesChangeLogs =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/verily.sdp.studysite.v1alpha1.StudySiteService/ListStudySitesChangeLogs',
      request,
      metadata || {},
      methodDescriptor_StudySiteService_ListStudySitesChangeLogs);
};


module.exports = proto.verily.sdp.studysite.v1alpha1;

